var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsLp3F8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 517,
    viewBox: "0 0 517 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_737)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 508.49 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 393.602 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 240.416 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 87.2305 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 431.896 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 278.713 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 125.527 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 317.008 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 163.822 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 470.193 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 355.305 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 202.119 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 48.9336 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 29.7852 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 10.6387 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 489.342 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 374.453 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 221.268 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 68.082 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 412.748 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 259.564 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 106.379 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 297.859 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 144.676 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 8.51025)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 238.288)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 123.399)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 353.177)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 85.103)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 314.881)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 199.992)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 429.77)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 468.066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 46.8066)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 276.584)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 161.695)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 391.473)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 27.6582)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 257.436)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 142.547)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 372.325)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 104.251)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 334.029)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 219.14)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 448.917)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 487.214)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 506.362)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 451.045 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 65.9546)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 295.732)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 180.844)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 336.156 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.06379,
    cy: 1.06379,
    r: 1.06379,
    transform: "matrix(-1 0 0 1 182.971 410.622)",
    fill: "#DADFF2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 507.426,
    height: 352.113,
    transform: "matrix(-1 0 0 1 515.936 164.887)",
    fill: "url(#paint0_linear_188_737)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 507.426,
    height: 352.113,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 352.113 508.489)",
    fill: "url(#paint1_linear_188_737)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_737",
    x1: 253.713,
    y1: 0,
    x2: 253.713,
    y2: 352.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_188_737",
    x1: 253.713,
    y1: 0,
    x2: 253.713,
    y2: 352.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 517,
    height: 517,
    fill: "white",
    transform: "matrix(-1 0 0 1 517 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsLp3F8);
export default __webpack_public_path__ + "static/media/dots-LP3F8.f588654719a93f171d09580ccf546cbc.svg";
export { ForwardRef as ReactComponent };